import React from 'react';

const PrivacyPolicy = () => {
  const sectionStyle = {
    marginLeft: '30px',
    marginBottom: '20px'
  };

  return (
    <div>

      <div style={sectionStyle}>
        <h2>Privacy Policy for Dakshya A.I Apps</h2>
        <p>Last Updated: 4 Dec 2025</p>
        <p>
          This Privacy Policy explains how <strong>Dakshya A.I</strong> handles information in our iOS applications (the “Apps”):
        </p>
        <ul>
          <li>Diabetes Sugar Tracker</li>
          <li>Menstruation Tracker</li>
        </ul>
        <p>
          Our Apps work completely offline and do not require you to create an account or share any personal information with us.
          All data you enter stays on your device only.
        </p>
      </div>

      <div style={sectionStyle}>
        <h3>1. What Data We Do NOT Collect</h3>
        <p>
          We do <strong>not</strong> collect, store, transmit, or process any user data.
          We do not operate any servers, and we do not receive any information from your device.
        </p>
      </div>

      <div style={sectionStyle}>
        <h3>2. What Data the Apps Store Locally</h3>
        <p>The Apps allow you to save data on your device, such as:</p>

        <h4>Diabetes Sugar Tracker</h4>
        <ul>
          <li>Blood sugar readings</li>
          <li>Weight</li>
          <li>Medications</li>
          <li>Notes</li>
        </ul>

        <h4>Menstruation Tracker</h4>
        <ul>
          <li>Period dates</li>
          <li>Notes</li>
        </ul>

        <p>
          This data is stored only on your iPhone inside the app’s local storage.
          We cannot access, read, or recover this data.
          If you delete the app, all data is permanently removed from your device.
        </p>
      </div>

      <div style={sectionStyle}>
        <h3>3. Third-Party Data Collection (AdMob)</h3>
        <p>
          We use <strong>Google AdMob</strong> to display advertisements in both Apps.
          We do not control or access any data that AdMob collects.
          AdMob may collect device-level information (such as device identifiers, IP address, and app interactions)
          for advertising and measurement.
          All such data is collected directly by Google, not by Dakshya A.I.
        </p>
        <p>
          For more details, please see Google’s Privacy Policy:<br />
          <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener noreferrer">
            https://policies.google.com/technologies/ads
          </a>
        </p>
      </div>

      <div style={sectionStyle}>
        <h3>4. Changes to This Privacy Policy</h3>
        <p>
          We may update this Privacy Policy from time to time.
          When changes are made, we will update the “Last Updated” date at the top of this page.
        </p>
      </div>

      <div style={sectionStyle}>
        <h3>5. Contact Us</h3>
        <p>If you have any questions about this Privacy Policy, you may contact us at:</p>
        <p>Email: info@dakshyaai.com</p>
        <p>Address: Pokhara, Nepal</p>
        <p>Website: dakshyaai.com</p>
      </div>
      
    </div>
  );
}

export default PrivacyPolicy;
